import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Alert, Box, Chip, Grid, Paper, Skeleton, Stack, Typography } from '@mui/material';
import React from 'react';
import { formatAge, isStale } from './model';

/**
 * Where a card's numbers come from. Fleet cards read the production scraper's documents in every environment,
 * while customer and login cards read this environment's database, so on develop the two sit side by side.
 */
export const SourceChip = _ref => {
  let prod = _ref.prod,
    at = _ref.at;
  return prod ? /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    variant: isStale(at) ? 'critical' : 'inactive',
    label: "Production scraper \xB7 ".concat(formatAge(at))
  }) : /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    variant: "inactive",
    label: "This environment"
  });
};
export const Card = _ref2 => {
  let title = _ref2.title,
    source = _ref2.source,
    children = _ref2.children,
    sx = _ref2.sx;
  return /*#__PURE__*/React.createElement(Paper, {
    sx: _objectSpread({
      padding: '16px',
      minWidth: 0
    }, sx)
  }, title || source ? /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    useFlexGap: true,
    spacing: 8,
    sx: {
      marginBottom: '12px'
    }
  }, title ? /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, title) : /*#__PURE__*/React.createElement("span", null), source) : null, children);
};

/** Loading and error for one card; renders children only once the data is in. */
export const Loaded = _ref3 => {
  let state = _ref3.state,
    children = _ref3.children;
  if (state.loading) {
    return /*#__PURE__*/React.createElement(Box, null, [90, 75, 60].map(w => /*#__PURE__*/React.createElement(Skeleton, {
      key: w,
      width: "".concat(w, "%")
    })));
  }
  if (state.error) return /*#__PURE__*/React.createElement(Alert, {
    severity: "error"
  }, state.error);
  return children;
};
export const KpiTiles = _ref4 => {
  let tiles = _ref4.tiles;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 12,
    sx: {
      marginBottom: '16px'
    }
  }, tiles.map(tile => /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 12 / tiles.length,
    key: tile.label
  }, /*#__PURE__*/React.createElement(Paper, {
    component: tile.onClick ? 'button' : 'div',
    onClick: tile.onClick,
    sx: {
      padding: '14px 16px',
      width: '100%',
      textAlign: 'left',
      border: 0,
      font: 'inherit',
      color: 'inherit',
      cursor: tile.onClick ? 'pointer' : 'default'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "text.secondary"
  }, tile.label), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    sx: {
      fontVariantNumeric: 'tabular-nums'
    }
  }, typeof tile.value === 'number' ? tile.value.toLocaleString() : tile.value)))));
};

/** A tiny trend with an emphasised last point. Values only; no axis, so it never claims a scale. */
export const Sparkline = _ref5 => {
  let values = _ref5.values,
    _ref5$width = _ref5.width,
    width = _ref5$width === void 0 ? 80 : _ref5$width,
    _ref5$height = _ref5.height,
    height = _ref5$height === void 0 ? 20 : _ref5$height,
    label = _ref5.label;
  if (!(values !== null && values !== void 0 && values.length)) {
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "text.secondary"
    }, "-");
  }
  const max = Math.max(1, ...values);
  const x = i => values.length === 1 ? width / 2 : 2 + i / (values.length - 1) * (width - 4);
  const y = v => height - 2 - v / max * (height - 4);
  const points = values.map((v, i) => "".concat(x(i), ",").concat(y(v))).join(' ');
  const last = values.length - 1;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    role: "img",
    "aria-label": label
  }, /*#__PURE__*/React.createElement("polyline", {
    points: points,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: x(last),
    cy: y(values[last]),
    r: "2.5",
    fill: "currentColor"
  }));
};